import React, { useEffect } from 'react';

import { useDispatch } from 'react-redux';
import { deleteBenefit } from '../actions/benefits'
import { FaTrash } from 'react-icons/fa';

type PropsBenefit = {
  benefit?: any;
  isForm?: boolean;
};

const Benefit: React.FC<PropsBenefit> = ({ isForm = false, benefit }) => {
  
  const dispatch = useDispatch();
  const imageUrl = benefit.image ? benefit.image : '';
  
  return (
    <>
      {/* // A mettre dans tailwind css !!!!  */}
      <div className="_flex _rounded-md _w-full _mb-md" style={{ boxShadow: "0 3px 15px rgba(0, 0, 0, 0.2)" }}>
        <section className="_w-auto">
          <div className="_m-md _bg-darkengreen _rounded-circle" style={{ height: '80px', width: '80px'}}>
              <img src={imageUrl} alt={benefit.title} style={{filter: 'brightness(0) invert(1)'}} className="_bg-no-repeat _bg-cover _bg-center _p-sm _w-full _h-full" />
          </div>
        </section>
        <section className="_w-full _my-xs _mr-xs _flex _flex-col">
          <h2>{benefit.title}</h2>
          <p>{benefit.description}</p>
        </section>
        {isForm && (
          <div className="_m-xs _absolute _right-lg">
            <button className="_ml-xs _text-warning _p-xxs hover:_bg-gray _rounded-card" type="button" onClick={() => dispatch(deleteBenefit(benefit._id))}>
              <FaTrash />
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default Benefit;
